import { useCallback } from 'react';

import { useAppDispatch } from 'shared/lib';

import type { TCreditFormCommonFields } from 'entities/creditForm';

import { sendCustomerDataThunk } from './sendCustomerDataThunk';

export const useSendCustomerData = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    (data: Partial<TCreditFormCommonFields>) => dispatch(sendCustomerDataThunk(data)).unwrap(),
    [dispatch],
  );
};
